
<template>
  <div class="refresh-ts" v-html="getShowTips"></div>
</template>
<script>
import { secondToDate, decodeHtml } from '@/common/js/utils.js'
const DAY_SECONDS = 86400
export default {
  props: ['refreshTs'],
  computed: {
    getShowTips () {
      if (this.refreshTs >= DAY_SECONDS) {
        const time = Math.floor(this.refreshTs / DAY_SECONDS)
        const str = this.$t('FoodC_C_Buy_again_iOeQ', {day: `<span>${time}</span>`})
        return decodeHtml(str)
      } else {
        return this.time
      }
    }
  },
  watch: {
    refreshTs: {
      handler (newV) {
        if (newV < DAY_SECONDS) {
          this.compTime(newV)
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      second: 0,
      time: '',
      t: ''
    }
  },
  methods: {
    compTime (newV) {
      const str = this.$t('FoodC_C_Buy_again_ScTm', {countdown: `<span>${secondToDate(newV)}</span>`})
      this.time = decodeHtml(str)

      this.second = newV - 1
      this.t = setInterval(() => {
        if (this.second <= 0) {
          clearInterval(this.t)
          this.$emit('update-data')
        } else {
          const str = this.$t('FoodC_C_Buy_again_ScTm', {countdown: `<span>${secondToDate(this.second)}</span>`})
          this.time = decodeHtml(str)
          this.second--
        }
      }, 1000)
    }
  },
  destroyed () {
    clearInterval(this.t)
  }
}
</script>
